export default "__VITE_ASSET__DP5OnoNC__"